import { AddCircle, Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab';
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField } from '@mui/material'
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput';
import ArgonTypography from 'components/ArgonTypography'
import { getDataWithResponse } from 'global/getFunc';
import { postSubmit } from 'global/postFunc';
import { useEffect, useState } from 'react';
import PropTypes from "prop-types";

const TambahProgram = ({
    decryptedUser, 
    opd, 
    updating, 
    setUpdating, 
    addReq, 
    tahunAnggaran, 
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [listProgram, setListProgram] = useState([])

    const [program, setProgram] = useState('')
    const [anggaran, setAnggaran] = useState('')
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)

    const reqProgram = () => {
        setListProgram([])
        setLoading(true)
        addReq()
        getDataWithResponse(
            '/admin-opd/get-dt-program-pd/' + opd.kd_pd,
            decryptedUser,
            (res) => {
                setListProgram(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
                setOpen(false)
            }
        );
    }

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/admin-opd/tr-perencanaan/tambah',
            {
                // id: `${tahunAnggaran.ta}-${opd}-${program.kd_program}`,
                id: `${tahunAnggaran.ta}-${opd.kd_pd}-${program.kode}`,
                ta: tahunAnggaran.ta,
                kd_pd: opd.kd_pd,
                kode: program.kode,
                program: program.kode,
                uraian: program.uraian,
                anggaran: anggaran.replace(/,(?=\d{3})/g, ''),
                target: '',
                ket: 'PROGRAM'
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                setOpen(false)
                setProgram('')
                setAnggaran('')
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                setOpen(false)
            }
        )
        // console.log('submit');
    }

    useEffect(() => {
        open && reqProgram()
        console.log(tahunAnggaran);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <>
            <ArgonButton
                variant='outlined'
                color="info"
                size="small"
                startIcon={<AddCircle />}
                onClick={handleOpen}
                {...props}
            >
                Tambah Program
            </ArgonButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Input Program</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Program
                            </ArgonTypography>
                        </ArgonBox>
                        <Autocomplete
                            id="combo-box-demo"
                            options={listProgram}
                            fullWidth
                            required
                            getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                            onChange={(event, newValue) => {
                                newValue !== null && setProgram(newValue)
                            }}
                            onInputChange={(event, newInputValue) => {
                                newInputValue === "" && setProgram('')
                                // newInputValue.length > 7 && reqDpt()
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Anggaran
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={anggaran}
                            onChange={handleAnggaranChange}
                            autoComplete='off'
                            startAdornment={
                                <InputAdornment position="start">
                                    <ArgonTypography component="label" variant="caption" >
                                        Rp
                                    </ArgonTypography>
                                </InputAdornment>
                            }
                        />
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

TambahProgram.propTypes = {
    decryptedUser: PropTypes.string.isRequired,
    opd: PropTypes.object.isRequired, 
    updating: PropTypes.bool.isRequired, 
    setUpdating: PropTypes.func.isRequired, 
    addReq: PropTypes.func.isRequired, 
    tahunAnggaran: PropTypes.object.isRequired, 
};

export default TambahProgram